import { toConfidenceScore } from '../../../types/branded';
import { type MatchRegel } from '../types';

// Reihenfolge = Priorität (erstes Match gewinnt bei Gleichstand)
export const MATCH_REGELN: readonly MatchRegel[] = [
  // ── VGÜ Spezifisch ────────────────────────────────────────────────────
  {
    id: 'vgü-lärm',
    pattern: /\b(vgü|vgu|vorsorge).{0,30}(lärm|laerm|gehör|audiom)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-03',
    tatbestandCode: 'L1',
    confidence: toConfidenceScore(92),
    grund: 'Titel enthält VGÜ + Lärm/Audiometrie-Keyword',
  },
  {
    id: 'vgü-bild',
    pattern: /\b(vgü|vgu|vorsorge).{0,30}(bildschirm|bsva|monitor|pc-arbeit)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-05',
    tatbestandCode: 'S1',
    confidence: toConfidenceScore(90),
    grund: 'Titel enthält VGÜ + Bildschirmarbeit-Keyword',
  },
  {
    id: 'vgü-nacht',
    pattern: /\b(vgü|vgu|vorsorge).{0,30}(nacht|schicht|wechsel)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-06',
    tatbestandCode: 'Psy2',
    confidence: toConfidenceScore(88),
    grund: 'Titel enthält VGÜ + Nacht-/Schichtarbeit',
  },
  {
    id: 'vgü-strahlung',
    pattern: /\b(vgü|vgu|vorsorge).{0,30}(strahlung|röntgen|radiolog|isotop)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-07',
    tatbestandCode: 'P1',
    confidence: toConfidenceScore(92),
    grund: 'Titel enthält VGÜ + Strahlung-Keyword',
  },
  {
    id: 'vgü-chemie',
    pattern: /\b(vgü|vgu|vorsorge).{0,30}(chemie|chem\.|benzol|lösem|staub|asbest)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-04',
    tatbestandCode: 'Ch5',
    confidence: toConfidenceScore(87),
    grund: 'Titel enthält VGÜ + Chemie/Staub-Keyword',
  },
  {
    id: 'vgü-einstellung',
    pattern: /\b(einstellungs|eintritts|aufnahme).{0,20}(untersuchung|uu|vgü)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-01',
    tatbestandCode: 'S7',
    confidence: toConfidenceScore(91),
    grund: 'Titel enthält Einstellungsuntersuchung-Keyword',
  },
  {
    id: 'vgü-allgemein',
    pattern: /(vgü|vgu|vorsorgeuntersuchung)/i,
    kategorie: 'VGÜ',
    leistungCode: 'VGÜ-02',
    tatbestandCode: 'S8',
    confidence: toConfidenceScore(75),
    grund: 'Titel enthält VGÜ (allgemein, kein spez. Keyword)',
  },
  // ── Begehung ──────────────────────────────────────────────────────────
  {
    id: 'begehung',
    pattern: /\b(betriebsbegehung|begehung|betriebsrundgang|arbeitsplatzbegehung)\b/i,
    kategorie: 'Begehung',
    leistungCode: 'BEG-01',
    confidence: toConfidenceScore(93),
    grund: 'Titel enthält Begehung-Keyword',
  },
  {
    id: 'gbu',
    pattern: /\b(gbu|gefährdungsbeurteilung|gefährdungs-beurteilung|risikobew)/i,
    kategorie: 'Begehung',
    leistungCode: 'BEG-03',
    confidence: toConfidenceScore(90),
    grund: 'Titel enthält GBU/Gefährdungsbeurteilung',
  },
  // ── ASA ───────────────────────────────────────────────────────────────
  {
    id: 'asa-sitzung',
    pattern: /\b(asa|arbeitssicherheits.?ausschuss|a\.s\.a\.)\b/i,
    kategorie: 'ASA',
    leistungCode: 'BEG-02',
    confidence: toConfidenceScore(94),
    grund: 'Titel enthält ASA-Keyword',
  },
  // ── Schulung ──────────────────────────────────────────────────────────
  {
    id: 'erste-hilfe',
    pattern: /\b(erste.?hilfe|ersthelfer|first.?aid)\b/i,
    kategorie: 'Schulung',
    leistungCode: 'BER-02',
    confidence: toConfidenceScore(90),
    grund: 'Titel enthält Erste-Hilfe-Keyword',
  },
  {
    id: 'unterweisung',
    pattern: /\b(unterweisung|sicherheitsunterweisung|brandschutzunterweisung|schulung)\b/i,
    kategorie: 'Schulung',
    leistungCode: 'BER-03',
    confidence: toConfidenceScore(85),
    grund: 'Titel enthält Schulung/Unterweisung-Keyword',
  },
  // ── Beratung ──────────────────────────────────────────────────────────
  {
    id: 'beratung',
    pattern: /\b(beratung|beratungsgespräch|konsult|besprechung.{0,10}arbeitsmed)\b/i,
    kategorie: 'Beratung',
    leistungCode: 'BER-01',
    confidence: toConfidenceScore(78),
    grund: 'Titel enthält Beratungs-Keyword',
  },
] as const;
